import React from "react";
import "./main.css";
import ResultsPage from "./components/ResultsPage";
import UploadPage from "./components/UploadPage";
import Cookies from "js-cookie";
import ExcelHeader from "./components/ExcelHeader";

export default class ExcelPage extends React.Component {
    constructor(props) {
        super(props);
        this.setFileUploaded = this.setFileUploaded.bind(this);

        let urlPathParams = new URLSearchParams(window.location.search);
        let programmeId = urlPathParams.get("programmeId");
        Cookies.set("programmeId", programmeId, { expires: 1 });
    }

    state = {
        selectedFile: null,
        fileUploaded: false,
        groupedResponse: null,
        singleResponse: null,
    };

    setFileUploaded = value => {
        this.setState({ fileUploaded: value });
    };

    setSelectedFile = value => {
        this.setState({ selectedFile: value });
    };

    setGroupedResponse = value => {
        this.setState({ groupedResponse: value });
    };

    setSingleResponse = value => {
        this.setState({ singleResponse: value });
    };

    render() {
        return (
            <>
                <ExcelHeader />
                {!this.state.singleResponse || !this.state.groupedResponse ? (
                    <UploadPage
                        style={{ textAlign: "center" }}
                        setFileUploaded={this.setFileUploaded}
                        setSelectedFile={this.setSelectedFile}
                        setGroupedResponse={this.setGroupedResponse}
                        setSingleResponse={this.setSingleResponse}
                        selectedFile={this.state.selectedFile}
                        groupedResponse={this.state.groupedResponse}
                        singleResponse={this.state.singleResponse}
                    />
                ) : (
                    <ResultsPage
                        style={{ textAlign: "center" }}
                        selectedFile={this.state.selectedFile}
                        groupedResponse={this.state.groupedResponse}
                        singleResponse={this.state.singleResponse}
                    />
                )}
            </>
        );
    }
}
